import * as types from './types';
// eslint-disable-next-line import/no-cycle
import axios from '@/lib/axios';
import Vue from 'vue';
import { errCodeMap } from '@/lib/errors';
import dayjs from 'dayjs';
import { getInventoryDesc } from '@/lib/helper';
import { saasTypeMap, statusMap } from '@/lib/enum';

export default {
  namespaced: true,
  state: {
    qqCrowdGoodList: [],
    contentId: null,
    isDialogSyncCrowd: false,
    isDialogCrowdShopwindow: false,
    pageInfo: {
      size: 1,
      count: 10,
      total: 100,
    },
  },
  mutations: {
    [types.SET_DIALOG_CROWD_SHOPWINDOW](state, isDialog) {
      state.isDialogCrowdShopwindow = isDialog;
    },
    [types.SET_CONTENT_ID](state, contentId) {
      state.contentId = contentId;
    },
    [types.SET_QQ_CROWD_GOOD_LIST](state, list) {
      state.qqCrowdGoodList = list;
    },
    [types.SET_DIALOG_SYNC_CROWD](state, isDialogSyncCrowd) {
      state.isDialogSyncCrowd = isDialogSyncCrowd;
    },
    // 页码区域
    [types.INIT_GOOD_CROWD_PAGE_INFO](state) {
      state.pageInfo = {
        ...state.pageInfo,
        size: 1,
        count: 10,
        total: 0,
      };
    },
    [types.SET_PRODUCT_LIST_PAGE_SIZE](state, size) {
      state.pageInfo.size = size;
    },
    [types.SET_PRODUCT_LIST_PAGE_COUNT](state, count) {
      state.pageInfo.count = count;
    },
    [types.SET_PRODUCT_LIST_PAGE_TOTAL](state, total) {
      state.pageInfo.total = total;
    },
  },
  actions: {
    async fetchQqCrowdGoodList({ commit, state, rootState }) {
      const { pageInfo, contentId } = state;
      const { profile } = rootState.userCenter;

      if (!contentId) {
        commit(types.SET_QQ_CROWD_GOOD_LIST, []);
        commit(types.SET_PRODUCT_LIST_PAGE_TOTAL, 0);
        return;
      }

      const params = {
        method: 'post',
        body: {
          uid: profile.uid,
          user_id: profile.user_id,
          content_id: contentId, // 视频、直播等内容id
          media_type: 4, // 1:微视 2:k歌  3:om
          page: pageInfo.size, // 页数 从1开始
          count: pageInfo.count, // 每页限制数
        },
      };
      const res = await axios.post('v1/media/product/state/binding_content', params)
        .catch(() => {
          Vue.prototype.$tip.error('获取内容橱窗商品列表失败');
        });
      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '获取内容橱窗商品列表失败');

        return;
      }

      const tableData = res.data.product_list.map(item => ({
        ...item,
        statusDesc: statusMap[item.status].title,
        statusColor: statusMap[item.status].color,
        priceDesc: `¥${(item.price / 100).toFixed(2)}`,
        commissionRateDesc: `¥${(item.commission / 100).toFixed(2)} / ${Number(item.commission_rate)}%`,
        mtimeDesc: dayjs(item.mtime).format('YYYY-MM-DD HH:mm:ss'),
        saasTypeDesc: saasTypeMap[item.saas_type] || '',
        inventoryDesc: getInventoryDesc(item),
        // 上架按钮是否展示
        showPushUpBtn:
          item.status !== 'auditing'
          && item.status !== 'onsale'
          && item.status !== 'refuse',
        // 下架按钮是否展示
        showPushDownBtn: item.status === 'onsale',
      }));

      commit(types.SET_QQ_CROWD_GOOD_LIST, tableData);
      commit(types.SET_PRODUCT_LIST_PAGE_TOTAL, res.data.page_info.total);
    },
  },
};
